import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jugendclub',
  templateUrl: './jugendclub.component.html',
  styleUrls: ['./../app.component.css']
})
export class JugendclubComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
